import {
  MultiSelectorContent,
  MultiSelectorTrigger,
  MultiSelectorValue,
  MultiSelectorItem,
  MultiSelectorList,
  MultiSelector,
  SelectContent,
  SelectTrigger,
  SelectValue,
  SelectItem,
  Select,
  Input,
} from '@ui/components';
import React from 'react';

const DynamicFilterSelect = ({
  placeholder,
  options,
  value,
  name,
  onChange,
}: {
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
  placeholder: string;
  value: string;
  name: string;
}) => {
  return (
    <Select onValueChange={onChange} value={value ?? ''} name={name}>
      <SelectTrigger className="w-full" size="small">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem value={option.value} key={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

const DynamicFilterMultiSelect = ({
  options,
  values,
  placeholder,
  onChange,
}: {
  options: { label: string; value: string }[];
  onChange: (value: string[]) => void;
  placeholder: string;
  values: string[];
}) => {
  return (
    <MultiSelector onValuesChange={onChange} values={values ?? []} className="w-full">
      <MultiSelectorTrigger size="small">
        <MultiSelectorValue placeholder={placeholder} />
      </MultiSelectorTrigger>
      <MultiSelectorContent>
        <MultiSelectorList>
          {options.map((option) => (
            <MultiSelectorItem value={option.value} label={option.label} key={option.value}>
              {option.label}
            </MultiSelectorItem>
          ))}
        </MultiSelectorList>
      </MultiSelectorContent>
    </MultiSelector>
  );
};

const DynamicFilterInput = ({
  placeholder,
  onChange,
  value,
  type,
  name,
}: {
  onChange: (value: string) => void;
  type: 'number' | 'text';
  placeholder: string;
  value: string;
  name: string;
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <Input
      placeholder={placeholder}
      onChange={handleChange}
      value={value ?? ''}
      inputSize="small"
      type={type}
      name={name}
      floating
    />
  );
};

export { DynamicFilterMultiSelect, DynamicFilterSelect, DynamicFilterInput };
